<template>
  <div class="minW1060-auto bg-fff mag10 pad10">

    <!-- 广告内容 -->
    <div v-show="!settingsShow">
      <el-tabs v-model="activeName" type="card" @tab-click="activeTab">
        <el-tab-pane label="通用广告" name="NORMAL"></el-tab-pane>
        <el-tab-pane label="商品广告" name="GOODS"></el-tab-pane>
        <el-tab-pane label="视频广告" name="VIDEO"></el-tab-pane>
        <el-tab-pane label="外链广告" name="OUT_LINK"></el-tab-pane>
      </el-tabs>

      <el-form ref="refFormCommon" :model="commonForm" class="mt20" label-width="200px">
        <el-form-item label="所属行业：" prop="industry" :rules="rules">
          <el-cascader
              clearable
              class="w200"
              placeholder="请选择"
              v-model="commonForm.industry"
              :options="industryList"
              :props="{value: 'adIndustryId', label: 'industryName'}"
          />
        </el-form-item>
        <el-form-item :label="titleLabel" prop="title" :rules="rules">
          <el-input
              style="width: 600px;"
              placeholder="请输入"
              v-model="commonForm.title"
          />
          <el-checkbox v-model="commonForm.titleArea" true-label="Y" false-label="N" class="ml10">
            标题插入位置信息
          </el-checkbox>
        </el-form-item>
        <el-form-item label="上传封面：" prop="cover" :rules="coverRules" required>
          <div class="mb10" v-if="activeName === 'NORMAL' || activeName === 'OUT_LINK'">
            <el-radio v-model="commonForm.cover" label="IMAGE">图片封面</el-radio>
            <el-radio v-model="commonForm.cover" label="VIDEO">视频封面</el-radio>
          </div>

          <more-img
              v-if="activeName !== 'VIDEO'"
              v-show="commonForm.cover === 'IMAGE'"
              v-model="commonForm.imgCover"
              :total="activeName === 'GOODS' ? 3 : 1"
          />

          <my-video
              v-show="commonForm.cover === 'VIDEO' || activeName === 'VIDEO'"
              v-model="commonForm.videoCover"
          />
        </el-form-item>
        <el-form-item v-if="activeName === 'GOODS'" label="商品价格" prop="goodsPrice" :rules="rules">
          <el-input
              style="width: 300px;"
              placeholder="请输入"
              v-model="commonForm.goodsPrice"
          />
        </el-form-item>
        <el-form-item v-if="activeName === 'GOODS' || activeName === 'VIDEO'"
                      :label="activeName === 'VIDEO' ? '视频按钮：' : '商品按钮：'">
          <el-button @click="addButtonBtn" :disabled="buttonBtnAddDisabled">添加</el-button>

          <el-table class="my-table mt10" style="width: 700px;" :data="commonForm.buttonList"
                    :header-row-class-name="'my-table-header'">
            <el-table-column align="center" prop="buttonName" label="按钮名称"></el-table-column>
            <el-table-column align="center" prop="buttonTypeName" width="100px" label="按钮类型"></el-table-column>
            <el-table-column align="center" prop="buttonContent" label="按钮内容"></el-table-column>
            <el-table-column align="center" label="操作" width="90px">
              <template slot-scope="scope">
                <a class="glob-a" @click="delButtonBtn(scope.$index)">删除</a>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item v-if="activeName !== 'OUT_LINK'" label="描述：" prop="content" :rules="rules">
          <my-edit v-model="commonForm.content"/>
        </el-form-item>

        <template v-if="activeName !== 'OUT_LINK'">

          <el-form-item label="联系电话：" prop="phone" :rules="rules">
            <el-input class="w200" v-model.number="commonForm.phone" type="number" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="上传位置信息：" prop="address" :rules="areaRules" required>
            <el-cascader
                clearable
                class="w300"
                placeholder="请选择"
                ref="refArea"
                v-model="commonForm.area"
                :options="areaList"
                :props="{value: 'amapAreaId', label: 'name'}"
            />
            <el-input v-model="commonForm.address" style="width: 300px;margin-left: 10px;"/>
          </el-form-item>
          <el-form-item label="是否需要用户提交信息：" prop="submitStatus" :rules="rules">
            <el-radio v-model="commonForm.submitStatus" label="Y">是</el-radio>
            <el-radio v-model="commonForm.submitStatus" label="N">否</el-radio>
          </el-form-item>
          <el-form-item label="是否开启广告评论：" prop="commentStatus" :rules="rules">
            <el-radio v-model="commonForm.commentStatus" label="Y">是</el-radio>
            <el-radio v-model="commonForm.commentStatus" label="N">否</el-radio>
          </el-form-item>
          <el-form-item label="底部导航按钮：">
            <el-button @click="addNavBtn" :disabled="navBtnAddDisabled">添加</el-button>

            <el-table class="my-table mt10" style="width: 700px;" :data="commonForm.navTable"
                      :header-row-class-name="'my-table-header'">
              <el-table-column align="center" prop="name" label="按钮名称"></el-table-column>
              <el-table-column align="center" prop="typeName" width="100px" label="按钮类型"></el-table-column>
              <el-table-column align="center" prop="content" label="按钮内容"></el-table-column>
              <el-table-column align="center" label="操作" width="90px">
                <template slot-scope="scope">
                  <a class="glob-a" @click="delNavBtn(scope.$index)">删除</a>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="广告链接：" prop="commentStatus" :rules="rules">
            <el-input
                style="width: 600px;"
                placeholder="请输入"
                v-model="commonForm.adLink"
            />
          </el-form-item>
        </template>
      </el-form>
    </div>

    <!-- 投放设置 -->
    <div v-show="settingsShow">
      <el-tabs type="card">
        <el-tab-pane label="设置投放"></el-tab-pane>
      </el-tabs>

      <el-form ref="refFormSettings" :model="settingsForm" class="mt20" label-width="200px">
        <el-form-item label="您的广告想推广给谁：" prop="spreadType" :rules="spreadRules" required>
          <div class="mb10">
            <el-radio v-model="settingsForm.spreadType" label="NATIONAL">全国</el-radio>
            <el-radio v-model="settingsForm.spreadType" label="AREA">区域</el-radio>
          </div>
          <div v-show="settingsForm.spreadType === 'AREA'">
            <div class="mb10">
              <el-select v-model="province" @change="provinceChange" class="w200 mr10">
                <el-option v-for="(item, index) in provinceList" :key="index" :label="item.name" :value="item.code"/>
              </el-select>
              <el-select v-model="city" class="w200 mr10" clearable>
                <el-option v-for="(item, index) in cityList" :key="index" :label="item.name" :value="item.code"/>
              </el-select>
              <el-button type="primary" @click="addSpreadBtn">添加</el-button>
            </div>

            <el-tag size="small" class="mr5" v-for="(item, index) in settingsForm.spreadAreaFormList" :key="index"
                    closable @close="delSpreadBtn(item)">
              {{item.name}}
            </el-tag>
          </div>
        </el-form-item>
        <el-form-item label="日花费上限：" prop="dayCostLimit" :rules="rules">
          <el-input v-model.number="settingsForm.dayCostLimit" type="number" style="width: 200px;" placeholder="请输入"/>
          元
        </el-form-item>
        <el-form-item label="总投入上限：" prop="totalCostLimit" :rules="rules">
          <el-input v-model.number="settingsForm.totalCostLimit" type="number" style="width: 200px;" placeholder="请输入"/>
          元
        </el-form-item>

        <el-form-item label="平台费用比例：">
          {{platformBenefitRate}}
        </el-form-item>
        <el-form-item label="平台费用：">
          {{Number(settingsForm.totalCostLimit * platformBenefitRate / 100).toFixed(2)}}
        </el-form-item>
        <el-form-item label="APP账号广告余额：">
          {{adBalance}}
        </el-form-item>

        <el-form-item label="是否设置追踪广告：" prop="trackFlag" :rules="rules">
          <el-radio v-model="settingsForm.trackFlag" label="Y">是</el-radio>
          <el-radio v-model="settingsForm.trackFlag" label="N">否</el-radio>
        </el-form-item>
        <el-form-item label="是否在红包地图显示红包：" prop="redPacketMapFlag" :rules="rules">
          <el-radio v-model="settingsForm.redPacketMapFlag" label="Y">是</el-radio>
          <el-radio v-model="settingsForm.redPacketMapFlag" label="N">否</el-radio>
        </el-form-item>
        <el-form-item label="红包显示位置：" prop="area" :required="settingsForm.redPacketMapFlag == 'Y'">
          <el-cascader
              clearable
              class="w300"
              placeholder="请选择"
              ref="refRedArea"
              v-model="settingsForm.area"
              :options="areaList"
              :props="{value: 'amapAreaId', label: 'name'}"
          />
          <el-input v-model="settingsForm.redPacketMapAddress" style="width: 300px;margin-left: 10px;"/>
        </el-form-item>
        <el-form-item label="广告付费方式：" prop="payType" :rules="rules">
          <el-radio v-model="settingsForm.payType" label="CLICK">点击付费</el-radio>
          <el-radio v-model="settingsForm.payType" label="RED_PACKET">拆红包付费</el-radio>
        </el-form-item>
        <el-form-item v-if="settingsForm.payType == 'RED_PACKET'" label="红包奖励规则：" prop="adRedPacketRulesId"
                      :rules="rules">
          <el-radio v-model="settingsForm.adRedPacketRulesId" :label="item.adRedPacketRuleId"
                    v-for="(item, index) in adRedPacketRulesIdList">
            {{item.ruleName}}
          </el-radio>
        </el-form-item>
        <el-form-item label="期望广告投放位置：" prop="putInPosition" :rules="rules">
          <el-radio v-model="settingsForm.putInPosition" label="LIST">列表</el-radio>
          <el-radio v-model="settingsForm.putInPosition" label="DETAIL">详情</el-radio>
          <el-radio v-model="settingsForm.putInPosition" label="CONTENT">内容</el-radio>
        </el-form-item>
      </el-form>
    </div>

    <div style="padding: 50px 0 50px 200px;">
      <template v-if="settingsShow">
        <el-button size="medium" type="primary" @click="settingsShow = false">上一步</el-button>
        <el-button size="medium" type="primary" @click="commonSave('refFormSettings', 'save')">投放</el-button>
      </template>
      <template v-else>
        <el-button size="medium" @click="commonSave('refFormCommon', 'view')">预览</el-button>
        <el-button size="medium" type="primary" @click="commonSave('refFormCommon','next')">下一步</el-button>
      </template>
    </div>

    <!-- 导航按钮 -->
    <el-dialog title="导航按钮" :visible.sync="navData.modal" width="400px">
      <el-form ref="refFormNav" label-width="100px" :model="navData">
        <el-form-item label="按钮名称：" prop="name" :rules="rules">
          <el-input v-model="navData.name" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="按钮类型：" prop="type" :rules="rules">
          <el-select v-model="navData.type" class="wp100">
            <el-option label="手机号" value="PHONE"/>
            <el-option label="网址" value="WEB_SITE"/>
          </el-select>
        </el-form-item>
        <el-form-item label="按钮内容：" prop="content" :rules="rules">
          <el-input v-model="navData.content" placeholder="请输入"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="navData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addNavSave">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 视频商品按钮 -->
    <el-dialog :title="activeName === 'GOODS' ? '商品按钮' : '视频按钮'" :visible.sync="buttonData.modal" width="400px">
      <el-form ref="refFormButton" label-width="100px" :model="buttonData">
        <el-form-item label="按钮名称：" prop="buttonName" :rules="rules">
          <el-input v-model="buttonData.buttonName" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="按钮类型：" prop="buttonType" :rules="rules">
          <el-select v-model="buttonData.buttonType" class="wp100">
            <el-option label="手机号" value="PHONE"/>
            <el-option label="网址" value="WEB_SITE"/>
          </el-select>
        </el-form-item>
        <el-form-item label="按钮内容：" prop="buttonContent" :rules="rules">
          <el-input v-model="buttonData.buttonContent" placeholder="请输入"/>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="buttonData.modal = false">取 消</el-button>
        <el-button type="primary" @click="addButtonSave">确 定</el-button>
      </div>
    </el-dialog>

    <!--    &lt;!&ndash; 发布 &ndash;&gt;-->
    <!--    <el-dialog title="投放" :visible.sync="sendData.modal" width="400px">-->
    <!--      <el-form :model="sendData" ref="refFormSend" label-width="100px">-->
    <!--        <el-form-item label="投放时间：" prop="date" :rules="rules">-->
    <!--          <el-date-picker-->
    <!--              v-model="sendData.date"-->
    <!--              type="date"-->
    <!--              value-format="yyyy-MM-dd"-->
    <!--              placeholder="选择日期"/>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->

    <!--      <div slot="footer">-->
    <!--        <el-button @click="sendData.modal = false">取 消</el-button>-->
    <!--        <el-button :loading="saveLoading" type="primary" @click="sendSave">确 定</el-button>-->
    <!--      </div>-->
    <!--    </el-dialog>-->
  </div>
</template>

<script>
  import {getAdIndustryTree, getAreaTree, getAdRuleList, addAd, getAdBeforeCondition} from '@/api'

  import MyEdit from '@/components/MyEdit'
  import MoreImg from '@/components/MoreImg'
  import MyVideo from '@/components/MyVideo.vue'

  export default {
    name: 'AdEdit',
    components: {MyEdit, MoreImg, MyVideo},
    data () {
      const areaValidate = (rule, value, callback) => {
        if (this.commonForm.area.length && this.commonForm.address) {
          callback()
        } else {
          callback(new Error('此输入框必填'))
        }
      }
      const coverValidate = (rule, value, callback) => {
        if (this.commonForm.cover === 'IMAGE' && this.activeName !== 'VIDEO' ? this.commonForm.imgCover.length : this.commonForm.videoCover) {
          callback()
        } else {
          callback(new Error('此输入框必填'))
        }
      }
      const spreadValidate = (rule, value, callback) => {
        if (this.settingsForm.spreadType === 'AREA') {
          if (this.settingsForm.spreadAreaFormList.length) {
            callback()
          } else {
            callback(new Error('此输入框必选'))
          }
        } else {
          callback()
        }
      }

      return {
        rules: this.$store.state.rules.required,
        coverRules: [
          {validator: coverValidate, trigger: 'blur'}
        ],
        areaRules: [
          {validator: areaValidate, trigger: 'blur'}
        ],
        spreadRules: [
          {validator: spreadValidate, trigger: 'blur'}
        ],
        activeName: 'NORMAL',
        commonForm: {
          industry: [],
          title: '',
          titleArea: 'N',
          cover: 'IMAGE',
          imgCover: [],
          videoCover: '',
          phone: '',
          area: [],
          address: '',
          commentStatus: 'Y',
          submitStatus: 'Y',
          content: '',
          navTable: [],
          buttonList: [],
          adLink: '',
          goodsPrice: ''
        },
        settingsForm: {
          spreadType: 'NATIONAL',
          spreadAreaFormList: [],
          trackFlag: 'Y',
          payType: 'CLICK',
          adRedPacketRulesId: '',
          putInPosition: 'LIST',
          dayCostLimit: '',
          totalCostLimit: '',
          redPacketMapFlag: 'Y',
          redPacketMapAddress: '',
          area: [],
        },
        // 行业树
        industryList: [],
        // 区域
        areaList: [],
        // 导航按钮
        navData: {
          modal: false,
          name: '',
          type: 'WEB_SITE',
          content: '',
        },
        // 视频商品按钮
        buttonData: {
          modal: false,
          buttonName: '',
          buttonContent: '',
          buttonType: 'WEB_SITE',
        },
        // 发布
        sendData: {
          modal: false,
          date: ''
        },
        // 投放设置
        settingsShow: false,
        // 省份集合
        province: '',
        provinceList: [],
        // 市集合
        city: '',
        cityList: [],
        // 奖励金额规则
        adRedPacketRulesIdList: [],
        saveLoading: false,
        // 广告帐户余额
        adBalance: '',
        // 平台分成比例
        platformBenefitRate: '',
      }
    },
    computed: {
      navBtnAddDisabled () {
        return this.commonForm.navTable.length > 1
      },
      buttonBtnAddDisabled () {
        return !!this.commonForm.buttonList.length
      },
      titleLabel () {
        return this.activeName === 'GOODS' ? '商品宣传语' :
          this.activeName === 'VIDEO' ? '视频宣传语' :
            '广告标题'
      }
    },
    created () {
      this.getAdIndustryTreeFn()
      this.getAreaTreeFn()
      this.getAdRuleListFn()

      this.getAdBeforeConditionFn()
    },
    methods: {
      delButtonBtn (index) {
        this.commonForm.buttonList.splice(index, 1)
      },
      addButtonSave () {
        this.$refs['refFormButton'].validate(valid => {
          if (valid) {
            const {buttonName, buttonContent, buttonType} = this.buttonData
            this.commonForm.buttonList.push({
              buttonName,
              buttonContent,
              buttonTypeName: buttonType === 'WEB_SITE' ? '网站' : '手机号',
              buttonType
            })
            this.buttonData.modal = false
          } else {
            return false
          }
        })
      },
      addButtonBtn () {
        this.buttonData = {
          modal: true,
          buttonName: '',
          buttonContent: '',
          buttonType: 'WEB_SITE',
        }
      },
      sendSave () {
        // this.$refs['refFormSend'].validate(valid => {
        //   if (valid) {
        let temp = {
          adIndustryId: this.commonForm.industry[this.commonForm.industry.length - 1],
          adType: this.activeName,
          spreadType: this.settingsForm.spreadType,
          spreadAreaFormList: this.settingsForm.spreadType === 'NATIONAL' ? [] : this.settingsForm.spreadAreaFormList,
          dayCostLimit: this.settingsForm.dayCostLimit,
          totalCostLimit: this.settingsForm.totalCostLimit,
          payType: this.settingsForm.payType,
          adRedPacketRulesId: this.settingsForm.adRedPacketRulesId,
          putInPosition: this.settingsForm.putInPosition,
          trackFlag: this.settingsForm.trackFlag,
          redPacketMapFlag: this.settingsForm.redPacketMapFlag,
          redPacketMapAddress: this.settingsForm.redPacketMapFlag == 'Y' ? this.$refs['refRedArea'].getCheckedNodes()[0].data.mergeName + this.settingsForm.redPacketMapAddress : '',
          // putInStartTime: this.sendData.date,
        }
        if (this.activeName === 'NORMAL') {
          temp.title = this.commonForm.title
          temp.titlePositionFlag = this.commonForm.titleArea
          temp.coverType = this.commonForm.cover
          temp.coverLinkUrl = this.commonForm.cover === 'IMAGE' ? this.commonForm.imgCover[0] : this.commonForm.videoCover
          temp.description = this.commonForm.content
          temp.visitorInfoFlag = this.commonForm.submitStatus
          temp.phone = this.commonForm.phone
          temp.address = this.$refs['refArea'].getCheckedNodes()[0].data.mergeName + this.commonForm.address
          temp.commentsFlag = this.commonForm.commentStatus
          temp.bottomButtonFlag = this.commonForm.navTable.length ? 'Y' : 'N'
          temp.bottomButtonFormList = this.commonForm.navTable
        } else if (this.activeName === 'OUT_LINK') {
          temp.title = this.commonForm.title
          temp.titlePositionFlag = this.commonForm.titleArea
          temp.outLinkUrl = this.commonForm.adLink
          temp.coverType = this.commonForm.cover
          temp.coverLinkUrl = this.commonForm.cover === 'IMAGE' ? this.commonForm.imgCover[0] : this.commonForm.videoCover
        } else if (this.activeName === 'GOODS') {
          temp.title = this.commonForm.title
          temp.titlePositionFlag = this.commonForm.titleArea
          temp.goodsImgList = this.commonForm.imgCover
          temp.goodsPrice = this.commonForm.goodsPrice
          temp.buttonName = this.commonForm.buttonList.length ? this.commonForm.buttonList[0].buttonName : ''
          temp.buttonContent = this.commonForm.buttonList.length ? this.commonForm.buttonList[0].buttonContent : ''
          temp.buttonType = this.commonForm.buttonList.length ? this.commonForm.buttonList[0].buttonType : ''
          temp.description = this.commonForm.content
          temp.visitorInfoFlag = this.commonForm.submitStatus
          temp.phone = this.commonForm.phone
          temp.address = this.$refs['refArea'].getCheckedNodes()[0].data.mergeName + this.commonForm.address
          temp.commentsFlag = this.commonForm.commentStatus
          temp.bottomButtonFlag = this.commonForm.navTable.length ? 'Y' : 'N'
          temp.bottomButtonFormList = this.commonForm.navTable
        } else if (this.activeName === 'VIDEO') {
          temp.title = this.commonForm.title
          temp.titlePositionFlag = this.commonForm.titleArea
          temp.videoUrl = this.commonForm.videoCover
          temp.description = this.commonForm.content
          temp.visitorInfoFlag = this.commonForm.submitStatus
          temp.buttonName = this.commonForm.buttonList.length ? this.commonForm.buttonList[0].buttonName : ''
          temp.buttonContent = this.commonForm.buttonList.length ? this.commonForm.buttonList[0].buttonContent : ''
          temp.buttonType = this.commonForm.buttonList.length ? this.commonForm.buttonList[0].buttonType : ''
          temp.phone = this.commonForm.phone
          temp.address = this.$refs['refArea'].getCheckedNodes()[0].data.mergeName + this.commonForm.address
          temp.commentsFlag = this.commonForm.commentStatus
          temp.bottomButtonFlag = this.commonForm.navTable.length ? 'Y' : 'N'
          temp.bottomButtonFormList = this.commonForm.navTable
        }

        this.saveLoading = true
        addAd(temp).then(res => {
          this.$message.success(res.data)
        }).finally(() => {
          this.saveLoading = false
        })
        //   } else {
        //     return false
        //   }
        // })
      },
      getAdRuleListFn () {
        getAdRuleList().then(res => {
          this.adRedPacketRulesIdList = res.data
        })
      },
      delSpreadBtn (row) {
        this.settingsForm.spreadAreaFormList = this.settingsForm.spreadAreaFormList.filter(item => item.areaCode !== row.areaCode)
      },
      addSpreadBtn () {
        if (!this.province && !this.city) {
          return false
        } else if (this.city) {
          const isHave = this.settingsForm.spreadAreaFormList.some(item => this.city === item.areaCode)
          if (isHave) {
            return false
          }
          const temp = this.cityList.find(item => this.city === item.code)
          this.settingsForm.spreadAreaFormList.push({
            areaCode: temp.code,
            areaLevel: temp.level.name,
            name: temp.name
          })
        } else {
          const isHave = this.settingsForm.spreadAreaFormList.some(item => this.province === item.areaCode)
          if (isHave) {
            return false
          }
          const temp = this.provinceList.find(item => this.province === item.code)
          this.settingsForm.spreadAreaFormList.push({
            areaCode: temp.code,
            areaLevel: temp.level.name,
            name: temp.name
          })
        }
      },
      provinceChange (val) {
        this.city = ''
        this.cityList = this.provinceList.find(item => val === item.code).children
      },
      commonSave (ref, t) {
        this.$refs[ref].validate(valid => {
          if (valid) {
            if (t === 'next') {
              this.settingsShow = true
            } else if (t === 'save') {
              // this.sendData = {
              //   modal: true,
              //   date: ''
              // }
              this.sendSave()
            }
          } else {
            return false
          }
        })
      },
      delNavBtn (index) {
        this.commonForm.navTable.splice(index, 1)
      },
      addNavSave () {
        this.$refs['refFormNav'].validate(valid => {
          if (valid) {
            const {name, type, content} = this.navData
            this.commonForm.navTable.push({
              name,
              type,
              typeName: type === 'WEB_SITE' ? '网站' : '手机号',
              content
            })
            this.navData.modal = false
          } else {
            return false
          }
        })
      },
      addNavBtn () {
        this.navData = {
          modal: true,
          name: '',
          type: 'WEB_SITE',
          content: '',
        }
      },
      activeTab () {
        if (this.activeName === 'GOODS' || this.activeName === 'VIDEO') {
          this.commonForm.cover = 'IMAGE'
        }
      },
      // 地区信息获取后拼接详细信息
      getAdIndustryTreeFn () {
        getAdIndustryTree().then(res => {
          this.industryList = res.data.children
        })
      },
      getAreaTreeFn () {
        getAreaTree().then(res => {
          this.areaList = res.data
          this.provinceList = res.data
        })
      },
      getAdBeforeConditionFn () {
        getAdBeforeCondition().then(res => {
          this.adBalance = res.data.adBalance
          this.platformBenefitRate = res.data.platformBenefitRate
        })
      }
    }
  }
</script>

<style scoped>
</style>
